var React = require('react');

function ArrowDownRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Icon_awesome-arrow-down","data-name":"Icon awesome-arrow-down","d":"M18.571,10.747l.99.99a1.066,1.066,0,0,1,0,1.512L10.895,21.92a1.066,1.066,0,0,1-1.512,0L.712,13.249a1.066,1.066,0,0,1,0-1.512l.99-.99a1.072,1.072,0,0,1,1.53.018l5.12,5.375V3.32a1.068,1.068,0,0,1,1.07-1.07H10.85a1.068,1.068,0,0,1,1.07,1.07V16.139l5.12-5.375A1.064,1.064,0,0,1,18.571,10.747Z","transform":"translate(-1.872 12.463) rotate(-45)","fill":"#6743c1"}));
}

ArrowDownRight.defaultProps = {"id":"arrow_down_right_icon","width":"27.904","height":"27.904","viewBox":"0 0 27.904 27.904"};

module.exports = ArrowDownRight;

ArrowDownRight.default = ArrowDownRight;
